import type { Lang } from "./types";

export function hrefWithLanguage(routeHref: string, lang: Lang): string | null {
  const url = new URL(routeHref, "https://storefront.invalid");
  if (url.searchParams.get("lang") === lang) return null;
  url.searchParams.set("lang", lang);
  return `${url.pathname}${url.search}${url.hash}`;
}
